import { InjectionToken } from '@angular/core';

export const TESTING_MODAL_CLOSE_ANIMATION_DISABLED = new InjectionToken<
  boolean
>('Testing ModalService Close Animation Disabled');
